import React, { memo, useEffect, useRef } from "react";
import { useTranslate } from "helpers";
import { ReactSVG } from "react-svg";
import { Loader } from "ui/components/Loader";
import { VehicleCardProps } from "./types";


const VehicleCard: React.FC<VehicleCardProps> = ({
    vehicleInfo,
    isActive,
    isCompleted,
    step,
    title,
    className,
    onSelectStep,
}) => {
    const { t } = useTranslate();


    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (isActive) {
            ref.current?.scrollIntoView({
                behavior: "smooth",
                inline: "center",
                block: "nearest",
            });
        }
    }, [isActive]);

    if (!isActive && !isCompleted)
        return null;

    return (
        <div
            ref={ref}
            role="button"
            tabIndex={0}
            onClick={onSelectStep}
            onKeyDown={(e) => e.key === "Enter" && onSelectStep?.()}
            className={className}
        >
            <div className="p-3 flex justify-between items-center min-h-[52px]">
                <h3 className="text-sm font-semibold text-slate-800">
                    {step}. {title}
                </h3>

                {isCompleted && (
                    <div className="bg-green-50 border-2 border-green-500 rounded-full p-1">
                        <ReactSVG
                            src="/media/icons/check.svg"
                            className="w-4 h-4 fill-green-500 stroke-green-500"
                        />
                    </div>
                )}
            </div>
            <div className="relative bg-white pt-4 pb-6 px-6 min-h-[120px]">
                {vehicleInfo?.isLoading && (
                    <div className="absolute inset-0 z-10 flex items-center justify-center bg-white/70">
                        <Loader isLoading={true}>{null}</Loader>
                    </div>
                )}
                <img
                    src={vehicleInfo?.vehicleImage || "/media/images/vehicles/vehicle-1.png"}
                    alt=""
                    className="w-full h-auto object-contain"
                />
            </div>
            <div className="px-4 py-2 text-slate-700 font-bold">
                {vehicleInfo?.vehicleManufacturerName ?? "-"} {vehicleInfo?.vehicleModelName ?? "-"} {vehicleInfo?.vehicleTypeName ?? "-"}
            </div>
            <div className="border-t border-slate-200 pb-4 p-4 space-y-2">


                <div className="flex justify-between text-sm">
                    <span className="text-slate-500">JOM:</span>
                    <span className="text-slate-700 font-medium">
                        {vehicleInfo?.jom ?? "-"}
                    </span>
                </div>

                <div className="flex justify-between text-sm">
                    <span className="text-slate-500 ">{t("admin.fleet.vehicle.add.vehicle.fueltype")}:</span>
                    <span className="text-slate-700 font-medium">
                        {vehicleInfo?.fuelType ?? "-"}
                    </span>
                </div>

                <div className="flex justify-between text-sm">
                    <span className="text-slate-500 ">{t("admin.fleet.vehicle.add.vehicle.transmission")}:</span>
                    <span className="text-slate-700 font-medium">
                        {vehicleInfo?.transmission ?? "-"}
                    </span>
                </div>

                <div className="flex justify-between text-sm">
                    <span className="text-slate-500 ">{t("admin.fleet.vehicle.add.vehicle.maximumpower")}:</span>
                    <span className="text-slate-700 font-medium">
                        <span className="text-slate-700 font-medium">
                            {vehicleInfo?.maximumPowerHp != null && vehicleInfo?.maximumPowerKw != null ? `${vehicleInfo.maximumPowerHp} HP / ${vehicleInfo.maximumPowerKw} kW` : "-"}
                        </span>

                    </span>

                </div>

               
            </div>
        </div>
    );
};

export default memo(VehicleCard);




